module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/universitycourse-hero-029165d3265d8993806204e274a831a6.svg";